import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Label, TabBar, TabItem } from '../components';
import cn from 'classnames';
import styles from './LandscapeStoryBaseEditTemplate.module.css';

interface OrganizationBaseAddTemplateProps {
  children: React.ReactNode;
}

const OrganizationBaseAddTemplate: React.FC<
  OrganizationBaseAddTemplateProps
> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content="Organization" size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate(`/organizations`)}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem title="Organization" id={`/organizations/add`} />
        <TabItem title="Content Blocks" id="" disabled />
        <TabItem title="Documents" id="" disabled />
        <TabItem title="Commodities" id="" disabled />
        <TabItem title="Landscapes" id="" disabled />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default OrganizationBaseAddTemplate;
